/** Build/runtime flags. Mock mode: `?mock` in the URL (sticky for the tab) or VITE_MOCK=1. */

import { desktopInfo } from "./desktop.ts";

export const APP_VERSION: string = __APP_VERSION__;
/** This web build: the commit it was made from and when (About, "Reload to update"). */
export const BUILD_COMMIT: string | null = __BUILD_COMMIT__;
export const BUILD_TIME: string = __BUILD_TIME__;

function detectMock(): boolean {
  if (import.meta.env.VITE_MOCK === "1") return true;
  try {
    const params = new URLSearchParams(location.search);
    if (params.has("mock")) {
      const on = params.get("mock") !== "0";
      sessionStorage.setItem("bundle.mock", on ? "1" : "0");
      return on;
    }
    return sessionStorage.getItem("bundle.mock") === "1";
  } catch {
    return false;
  }
}

export const MOCK = detectMock();
/** Separate persisted caches per mode so mock data never mixes with real data. */
export const STORAGE_NAMESPACE = MOCK ? "bundle-mock" : "bundle";
/**
 * API origin ("" = same origin: bundle-web forwards /v1 and /auth, Vite proxies them in dev). The desktop app serves
 * this build from tauri://localhost, so it names the API itself (window.__BUNDLE_DESKTOP__.apiUrl, set by Rust).
 */
export const API_BASE: string = import.meta.env.VITE_API_URL ?? desktopInfo()?.apiUrl ?? "";
/** Origin of links meant for a browser (copied links, "open in browser"): this page's, or the web app's on desktop. */
export const WEB_ORIGIN: string = desktopInfo()?.webUrl ?? (typeof location === "undefined" ? "" : location.origin);
